import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Worklog } from '../worklogs.model';
import { Router, ActivatedRoute } from '@angular/router';
import { WorklogsRest } from '../worklogs.rest';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { WorklogHeaderComponent } from './worklog-header/worklog-header.component';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { IssueService } from '../../issues/issue.service';
import { Issue } from '../../issues/issues.model';

@Component({
  selector: 'app-worklog-details',
  templateUrl: './worklog-details.component.html',
  styleUrls: ['./worklog-details.component.scss']
})
export class WorklogDetailsComponent implements OnInit, HasPermissions, AfterViewInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private rest: WorklogsRest,
    private permissionsService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService,
    private issueService: IssueService
  ) {
  }


  public worklog: Worklog;
  public isNew = false;
  public viewEnabled = false;
  public issue: Issue;
  public isCopy = false;
  private isSaving = false;

  private menuButtons: MenuButton[] = [
    { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.save(); }, enabled: false, isForSelected: false },
    { text: 'COMMONBUTTONS_close', class: "btn-danger", icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
  ];
  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.save(); }, enabled: false, isForSelected: false };

  permissions: Permissions;

  @ViewChild(WorklogHeaderComponent) worklogHeaderComponent: WorklogHeaderComponent;

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.save();
    event.preventDefault();
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions('Worklog');
    if (this.permissions.canAdd || this.permissions.canEdit) {
      this.menuButtons.find(x => x.text === 'COMMONBUTTONS_save').enabled = true;
      this.saveButton.enabled = true;
    }

    this.route.queryParams.subscribe(params => {
      if (params.isCopy) {
        this.isCopy = params.isCopy;
        this.rest.copyWorklog(this.route.snapshot.params['Id']).subscribe(worklog => {
          this.isNew = true;
          this.worklog = worklog;
          this.worklog.workDate = new Date();
          this.worklogHeaderComponent.setModel(this.worklog, this.isNew, null, this.permissions);
          this.spinnerService.hide();
        });
      }
      else {
        this.issueService.currentIssue.subscribe((issue: Issue) => {
          if (issue) {
            this.issue = issue;
          } else {
            this.issue = null
          }
        });
        this.spinnerService.show();
        let worklogId: number = null;
        if (params.id !== undefined) {
          worklogId = parseInt(params.id);
        }
        if (worklogId !== null) {
          if (worklogId > 0) {
            this.isNew = false;
            this.rest.getWorklog(worklogId).subscribe(worklog => {
              this.worklog = worklog;
              if (this.issue) {
                this.worklog.forIssue = true;
              }
              this.worklogHeaderComponent.setModel(this.worklog, this.isNew, this.issue, this.permissions);
              this.spinnerService.hide();
            });
          } else {
            this.isNew = false;
            this.worklog = this.issue.worklogs.find(x => x.id === worklogId);
            if (this.issue)
              this.worklog.forIssue = true;
            this.worklogHeaderComponent.setModel(this.worklog, this.isNew, this.issue, this.permissions);
            this.spinnerService.hide();
          }
        }
        else {
          this.isNew = true;
          this.rest.getEmptyWorklog().subscribe(worklog => {
            this.worklog = worklog;
            if (this.issue)
              this.worklog.forIssue = true;
            this.worklogHeaderComponent.setModel(this.worklog, this.isNew, this.issue, this.permissions);
            this.spinnerService.hide();
          });
        }
      }
    });
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  public save() {
    if (this.worklogHeaderComponent.isInvalid()) {
      sweetAlert('Dane sa niekomplete, nie mozna zapisać');
      return;
    }
    if (this.worklogHeaderComponent.worklog.invoiceTime === 0) {
      sweetAlert('Czas fakturowany jest równy zero. Czy kontynuować zapis?', {
        buttons: {
          yes: {
            text: "Tak",
            value: "yes"
          },
          no: {
            text: "Nie",
            value: "no",
          }
        }
      })
        .then((value) => {
          switch (value) {
            case "yes":
              this.saveWorklog();
              break;
          }
        });
    } else {
      this.saveWorklog();
    }
  }

  private saveWorklog() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    if (this.worklog.forIssue) {
      this.worklog.employeeFullName = this.worklogHeaderComponent.employeesRows.find(x => x.id === this.worklog.employeeId).name;
      this.worklog.numberString = this.worklog.numeratorType + '/' + this.worklog.year.toString() + '/' + this.worklog.serie + '/' + this.worklog.number;
      if (this.worklog.id !== 0 && this.worklog.issueId === this.issue.id) {
        this.issue.worklogs.splice(this.issue.worklogs.indexOf(this.worklog), 1);
        this.issue.worklogs.push(this.worklog);
      } else if (this.worklog.issueId === this.issue.id && this.issue.id === 0) {
        this.worklog.id = (this.issue.worklogs.length !== 0 ? (-1) * Math.min.apply(Math, this.issue.worklogs.map(function (o) { return o.id; })) : 0);
        this.issue.worklogs.push(this.worklog);
      }
    }
    if ((this.worklog.id >= 0 && !this.worklog.forIssue) || (this.worklog.forIssue && this.issue.id !== 0)) {
      const action = this.rest.saveWorklog;
      action.call(this.rest, this.worklog).subscribe(id => {
        if (this.isNew) {
          this.gridParamsRestoringService.saveAddingNewRowInfo(id);
        }
        if (this.worklog.forIssue && this.issue.id !== 0) {
          this.worklog.id = id;
          this.issue.worklogs.push(this.worklog);
        }
        this.isSaving = false;
        this.close();
      }, (error) => {
        this.isSaving = false;
      });
    } else {
      this.isSaving = false;
      this.close();
    }
  }

  private close() {
    this.issueService.passIssue(this.issue);
    let pathToReturn = '../../';
    if (this.isCopy) {
      pathToReturn = '../../../';
    }
    if (this.issue) {
      this.router.navigate([pathToReturn], { queryParams: { id: this.issue.id }, relativeTo: this.route });
    } else {
      this.router.navigate([pathToReturn], { relativeTo: this.route });
    }
  }

}
